import apiClient from '@/plugins/axios'

export default {
  getIntegradores() {
    return apiClient.get('integracao')
  },

  getIntegrador(id) {
    return apiClient.get(`integracao/${id}`)
  },

  postIntegrador(integrador) {
    return apiClient.post(`integracao`, { integrador })

  },

  putIntegrador(id, integrador) {
    return apiClient.put(`integracao/${id}`, { integrador })

  },

  deleteIntegrador(id) {
    return apiClient.delete(`integracao/${id}`)

  },

  getDropDown(id) {
    return apiClient.get(`integracao/dropdown/${id}`)
  },

}


// WEBPACK FOOTER //
// ./src/views/IntegradoresApi/_services/IntegradoresService.js